export default "__VITE_ASSET__BtAy26Ps__"